import { AsyncButton, AsyncButtonProps } from "src/components/common/buttons/AsyncButton";
import i18n from "i18next";
import { faTable } from "@fortawesome/pro-regular-svg-icons";
import { PartConfigurationDetailsView } from "src/components/views/erp/configurator/inspecting/PartConfigurationDetailsView.tsx";
import { useGenericDialog } from "src/components/common/dialogs/GenericDialogContext.ts";
import { PartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/partConfiguratorType.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface OpenPartConfigurationButtonProps extends Omit<AsyncButtonProps, "onClick"> {
	partConfigurationId: number | undefined | null; // hidden if null
	partConfiguratorType: PartConfiguratorType;
	showBom?: boolean;
	vatPercent?: number;
}

export const OpenPartConfigurationButton = ({
	partConfigurationId,
	partConfiguratorType,
	showBom,
	variant = "menu",
	vatPercent,
	...other
}: OpenPartConfigurationButtonProps) => {
	const { openDialog } = useGenericDialog();

	if (partConfigurationId == null) return;

	return (
		<AsyncButton
			label={i18n.t("configuration")}
			icon={faTable}
			variant={variant}
			onClick={() => {
				openDialog(() => ({
					title: i18n.t("configuration"),
					content: (
						<PartConfigurationDetailsView
							partConfigurationId={partConfigurationId!}
							partConfiguratorType={partConfiguratorType}
							showBom={showBom}
							vatPercent={vatPercent}
						/>
					),
					agentContext: {
						key: defineAgentUiContextKey("erp.configurator.openPartConfiguration.dialog"),
						title: i18n.t("configuration"),
						data: {
							partConfigurationId: partConfigurationId,
						},
					},
				}));
			}}
			{...other}
		/>
	);
};
